export function money(value) {
  return `PHP ${Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function printReceipt(receipt) {
  if (!receipt) return;

  const issuedAt = receipt.issued_at
    ? new Date(receipt.issued_at).toLocaleString()
    : "-";

  const html = `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <title>Official Receipt ${receipt.receipt_number || ""}</title>
    <style>
      body { font-family: Arial, sans-serif; margin: 24px; color: #0f172a; }
      .wrap { max-width: 780px; margin: 0 auto; border: 1px solid #cbd5e1; padding: 24px; border-radius: 12px; }
      h1 { margin: 0 0 4px; font-size: 24px; }
      h2 { margin: 18px 0 8px; font-size: 16px; }
      .muted { color: #64748b; font-size: 12px; }
      .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px 16px; margin-top: 12px; }
      .line { border-top: 1px solid #e2e8f0; margin: 14px 0; }
      .row { display: flex; justify-content: space-between; margin: 6px 0; }
      .strong { font-weight: bold; }
      @media print {
        body { margin: 0; }
        .wrap { border: none; border-radius: 0; }
      }
    </style>
  </head>
  <body>
    <div class="wrap">
      <h1>Official Receipt</h1>
      <p class="muted">Receipt No: ${receipt.receipt_number || "-"} | Issued: ${issuedAt}</p>
      <div class="line"></div>
      <h2>Tenant</h2>
      <div class="grid">
        <div><span class="muted">Name</span><div class="strong">${receipt.tenant_name || "-"}</div></div>
        <div><span class="muted">Email</span><div class="strong">${receipt.tenant_email || "-"}</div></div>
      </div>
      <h2>Property</h2>
      <div class="grid">
        <div><span class="muted">Property</span><div class="strong">${receipt.property_name || "-"}</div></div>
        <div><span class="muted">Location</span><div class="strong">${receipt.property_location || "-"}</div></div>
      </div>
      <h2>Payment</h2>
      <div class="grid">
        <div><span class="muted">Month</span><div class="strong">${receipt.month_paid_for || "-"}</div></div>
        <div><span class="muted">Method</span><div class="strong">${receipt.method || "-"}</div></div>
        <div><span class="muted">Reference</span><div class="strong">${receipt.reference_number || "-"}</div></div>
        <div><span class="muted">Type</span><div class="strong">${receipt.payment_type || "-"}</div></div>
      </div>
      <div class="line"></div>
      <div class="row"><span>Amount Paid</span><span class="strong">${money(receipt.amount)}</span></div>
      <div class="row"><span>Balance Before</span><span>${money(receipt.balance_before)}</span></div>
      <div class="row"><span>Balance After</span><span>${money(receipt.balance_after)}</span></div>
      <div class="line"></div>
      <p class="muted">Reviewed by: ${receipt.approved_by || "-"} | Payment ID: ${receipt.payment_id || "-"}</p>
    </div>
    <script>window.print();</script>
  </body>
</html>`;

  const receiptWindow = window.open("", "_blank", "width=900,height=900");
  if (!receiptWindow) return;
  receiptWindow.document.open();
  receiptWindow.document.write(html);
  receiptWindow.document.close();
}

